import { render, staticRenderFns } from "./Extrainfo.vue?vue&type=template&id=7bb4c027&"
import script from "./Extrainfo.vue?vue&type=script&lang=js&"
export * from "./Extrainfo.vue?vue&type=script&lang=js&"
import style0 from "./Extrainfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports